"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownLink = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _link = require("../../link");

var _PageHeaderLink = require("./PageHeaderLink");

var SpanRow = _layout.Row.withComponent('span', {
  target: "e1fwququ0"
});

var PageHeaderDropdownLinkWithoutDocs = function PageHeaderDropdownLinkWithoutDocs(_ref) {
  var icon = _ref.icon,
      dataTestId = _ref.dataTestId,
      children = _ref.children,
      _ref$wrapper = _ref.wrapper,
      Wrapper = _ref$wrapper === void 0 ? _link.Link : _ref$wrapper,
      linkProps = (0, _objectWithoutProperties2.default)(_ref, ["icon", "dataTestId", "children", "wrapper"]);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderDropdownLink',
    dataTestId: dataTestId
  });
  var linkCss = (0, _react.useMemo)(function () {
    return (
      /*#__PURE__*/
      (0, _core.css)({
        backgroundColor: selectors.color('white'),
        height: '100%',
        '&:hover': {
          backgroundColor: selectors.color('primaryTint'),
          textDecoration: 'none'
        },
        '&:focus': {
          outlineOffset: '-2px'
        }
      }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  }, [selectors]);
  return (0, _core.jsx)(Wrapper, (0, _extends2.default)({
    fontWeight: "regular",
    textDecoration: "none",
    css: linkCss,
    display: "block"
  }, linkProps, dataTestProps), (0, _core.jsx)(SpanRow, {
    alignItems: "center",
    gridGap: icon ? 'S100' : undefined,
    height: "100%",
    padding: [16, 24]
  }, !!icon && icon, !!children && children));
};

var PageHeaderDropdownLinkStyled = PageHeaderDropdownLinkWithoutDocs;

PageHeaderDropdownLinkStyled.withComponent = function (tag) {
  var Wrapper = _link.Link.withComponent(tag, {
    target: "e1fwququ1"
  });

  Wrapper.defaultProps = (0, _objectSpread2.default)({}, _link.Link.defaultProps);
  return function (props) {
    return (0, _core.jsx)(PageHeaderDropdownLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};

var PageHeaderDropdownLink = (0, _stencilReactDesc.describe)(PageHeaderDropdownLinkStyled).description('Link dropdown item for PageHeader.');
exports.PageHeaderDropdownLink = PageHeaderDropdownLink;
PageHeaderDropdownLink.displayName = 'PageHeaderDropdownLink';
PageHeaderDropdownLink.propTypes = (0, _objectSpread2.default)({}, _link.Link.describedPropTypes, (0, _utils.pick)(_PageHeaderLink.PageHeaderLink.describedPropTypes, ['dataTestId', 'children', 'icon']));